import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import Translate from 'client/components/translate';
import Button from 'client/components/button/button';
import BottomBarContainer from 'client/components/bottomBarContainer';
import DetailVision from 'client/components/plan/detail/vision';
import BenefitCostList from 'client/components/benefit/costList';
import FunnelCard from 'client/components/plan/card/funnelCard';
import FunnelStep from 'client/components/funnelStep';
import { postPlan, updateApp } from 'client/actions/ifpApps';
import { fetchBundle } from 'client/actions/plans/vision';
import { currency } from 'client/utils/format';

import 'client/styles/planDetail.scss';
import 'client/styles/accordion.scss';

const mapStateToProps = (state) => {
  const visionApp = _.find(state.ifpApps, { type: 'vision' });

  return {
    appId: visionApp ? visionApp.app_id : null,
    address: visionApp ? visionApp.address : {},
    members: visionApp ? visionApp.members : [],
    plan: state.visionPlans.plans[0], // TODO: fix to pull id from route param
    effectiveDate: state.visionPlans.effectiveDate,
    isAuthenticated: !!state.user.isLoggedIn,
    translations: state.translations,
    isStandAlone: _.every(state.cart.ifpApps, { type: 'vision' }),
  };
};

const propTypes = {
  plan: PropTypes.object,
  appId: PropTypes.string,
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
  address: PropTypes.object.isRequired,
  effectiveDate: PropTypes.string,
  fetchBundle: PropTypes.func.isRequired,
  postPlan: PropTypes.func.isRequired,
  updateApp: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  translations: PropTypes.shape().isRequired,
  isStandAlone: PropTypes.bool.isRequired,
};

const defaultProps = {
  appId: null,
  plan: null,
  effectiveDate: null,
};

export class PlanDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    this.props.fetchBundle({
      buyDate: new Date(),
      appMembers: this.props.members,
      address: this.props.address,
    });
  }

  setSubmitting(state) {
    this.setState({
      isSubmitting: state,
    });
  }

  postPlan = () => {
    const { plan, isStandAlone } = this.props;
    this.setSubmitting(true);

    return this.props
      .postPlan(this.props.appId, {
        plan,
        premium: plan.premiumMonth,
        plan_id: plan.id,
        carrier_id: plan.carrierId,
      })
      .then(() => {
        if (this.props.isAuthenticated) {
          const redirect = isStandAlone ? '/purchase' : '/cart';
          window.location.assign(redirect);
        } else {
          this.props.updateApp('vision', {
            app_json: {
              plan,
            },
          });
          this.props.router.push('/onboarding/account');
        }
      })
      .catch(() => this.setSubmitting(false));
  };

  render() {
    const { plan, members, effectiveDate } = this.props;

    if (!plan || !plan.benefits) {
      return null;
    }

    const funnelCardProps = {
      plan,
      members,
      type: 'vision',
      premium: plan.premiumMonth,
      effectiveDate,
      ribbonStatus: { content: 'vision.card.ribbon', classes: { className: 'gtg' } },
    };

    const benefits = plan.benefits || [];
    const wellVision = _.find(benefits, { serviceType: 'exam_wellvision' });
    const contacts = _.find(benefits, { serviceType: 'contacts' });
    const costList = [
      {
        key: 'vision.card.benefits.exam_wellvision',
        value: currency(_.get(wellVision, 'amountMax', 0)),
      },
      {
        key: 'vision.card.benefits.eyeware_basic',
        value: currency(_.get(contacts, 'amountMax', 0)),
      },
    ];

    const barContent = (
      <div className="medium-table v-middle">
        <div
          className="td medium-6 hide-for-small-only text-right"
          style={{ paddingRight: '2rem' }}>
          <Translate path="vision.planDetails.bottomBar.description" />
        </div>
        <div className="td medium-6">
          <Button
            className={cx('cta-button full show-for-small-only animate', {
              submitting: this.state.isSubmitting,
            })}
            clickHandler={this.postPlan}>
            <Translate path="vision.planDetails.bottomBar.cta" />
          </Button>
          <Button
            className={cx('cta-button full hide-for-small-only', {
              submitting: this.state.isSubmitting,
            })}
            clickHandler={this.postPlan}>
            <Translate path="vision.planDetails.bottomBar.cta" />
          </Button>
        </div>
      </div>
    );

    return (
      <FunnelStep index={2} descriptKey="vision.nav.plans">
        <BottomBarContainer barContent={barContent}>
          <div className="center-col plan-detail">
            <div className="pad-bottom-2 margin-bottom-2">
              <FunnelCard {...funnelCardProps}>
                <div className="td medium-6">
                  <BenefitCostList benefits={costList} isPostDeductible={false} />
                </div>
              </FunnelCard>
            </div>

            <DetailVision context="onboarding" plan={plan} translations={this.props.translations} />
          </div>
        </BottomBarContainer>
      </FunnelStep>
    );
  }
}

PlanDetailPage.propTypes = propTypes;
PlanDetailPage.defaultProps = defaultProps;

export default connect(mapStateToProps, {
  fetchBundle,
  postPlan,
  updateApp,
})(PlanDetailPage);
